// Retrieved from AG-Grid v26 source code
// see https://github.com/ag-grid/ag-grid/blob/vDocs-26.1.0-20211102/community-modules/core/src/ts/utils/dom.ts
// These functions have been removed in AG-Grid v27
export function addCssClass(element, className) {
    if (!Boolean(element) || !Boolean(className) || className.length === 0) {
        return;
    }
    if (className.indexOf(' ') >= 0) {
        className.split(' ').forEach(value => addCssClass(element, value));
        return;
    }
    if (Boolean(element.classList)) {
        element.classList.add(className);
    }
    else if (element.className && element.className.length > 0) {
        const cssClasses = element.className.split(' ');
        if (cssClasses.indexOf(className) < 0) {
            cssClasses.push(className);
            element.setAttribute('class', cssClasses.join(' '));
        }
    }
    else {
        // do not use element.classList = className here, it will cause
        // a read-only assignment error on some browsers (IE/Edge).
        element.setAttribute('class', className);
    }
    // eslint-disable-next-line consistent-return
    return element;
}
export function removeCssClass(element, className) {
    if (!Boolean(element) || !Boolean(className) || className.length === 0) {
        return;
    }
    if (className.indexOf(' ') >= 0) {
        className.split(' ').forEach(value => removeCssClass(element, value));
        return;
    }
    if (Boolean(element.classList)) {
        element.classList.remove(className);
    }
    else if (element.className && element.className.length > 0) {
        const newClassName = element.className.split(' ').filter(elementClassName => elementClassName !== className).join(' ');
        element.setAttribute('class', newClassName);
    }
}
export function addOrRemoveCssClass(element, className, addOrRemove) {
    if (addOrRemove) {
        addCssClass(element, className);
    }
    else {
        removeCssClass(element, className);
    }
}
